import { render } from "./App.vue?vue&type=template&id=ced73e1a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=ced73e1a&lang=css"

import exportComponent from "D:\\Pranav\\Coding\\MyProjects\\Own Projects\\todo_list_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__